<div class="font-Inter sticky top-0 nottablet:-m-[24px]">
  @if (is_mobile() || is_tablet()) {
  <div class="header bg-primaryColor text-white text-center text-lg font-semibold py-2 px-4 flex justify-between
        items-center nottablet:hidden">
    <span>Travellers</span>
    <span class="cursor-pointer" (click)="close()">
      <i class="material-icons hover:bg-slate-200 rounded-full p-1">close</i>
    </span>
  </div>
  }
  <div class="content ">
    <div class="border-b border-[#E3EBF5]">
      <div class=" flex justify-between items-center p-3 px-4 rounded-md">
        <span class="font-semibold text-lg">No. of travellers</span>
        <div class="flex items-center gap-3">
          <i class="material-icons prevent-select rounded-md border border-gray-300 p-1 cursor-pointer active:border active:border-primaryColor hover:border-primaryColor"
            (click)="onChangeTraveller('remove')">remove</i>
          <span class="primary-text font-semibold">
            {{totalTraveller}}
          </span>
          <i class="material-icons prevent-select border border-gray-300 rounded-md p-1 cursor-pointer active:border active:border-primaryColor active:shadow-lg hover:border-primaryColor"
            (click)="onChangeTraveller('add')">add</i>
        </div>
      </div>
    </div>
  </div>

  <form #travellerAddform="ngForm">
    <div class="p-4 overflow-auto"
      [style.max-height]="!is_mobile() && !is_tablet() ? 'calc(100vh - ' + modalHeight + ')' : 'calc(100vh - 168px)'">
      <div class="font-semibold text-base text-zinc-500 mb-3 font-inter">
        <span>Age Of Travellers</span>

      </div>
      <div class="grid grid-cols-1 gap-y-5">
        @for (el of totalTravellerArr; track el; let idx = $index) {
        <div class="flex justify-between items-center gap-2">
          <div class="font-medium w-[4.8rem]">Traveller {{el}}:</div>
          <div>
            <select [(ngModel)]="selectedAges[idx]" required #travellerAdd="ngModel" (change)="onAgeChange(idx, $event)"
              name="age{{idx}}"
              [ngClass]="travellerAdd?.errors?.['required'] && (travellerAdd.touched || travellerAddform.submitted || isSearchSubmitted) ? 'border border-red-700': null"
              class="custom-select px-2 py-2 w-[140px]
                             bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
              <option value="" selected disabled>Select Age</option>
              @for (age of ageArr; track age) {
              <option [value]="age.value">
                {{age.label}}
              </option>
              }
            </select>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="p-2 border-t border-gray-200 mobile:hidden">
      <div class="flex justify-between items-center gap-2 mobile:hidden">
        <button mat-flat-button class="primary-bg rounded-xl white-text flex-grow h-[41px]"
          (click)="travellerAddform.valid ? applySelection(): null">
          <span class="white-text">APPLY</span>
        </button>
      </div>
    </div>

    <div
      class=" mobile:fixed  mobile:border-t mobile:border-gray-200 mobile:bottom-0 mobile:w-full mobile:p-2 mobile:bg-white">
      <button mat-raised-button class="primary-bg w-full min-h-13 rounded-lg notmobile:hidden"
        (click)="travellerAddform.valid ? applySelection(): null">
        <span class="white-text font-semibold text-lg">Apply</span>
      </button>
    </div>
  </form>
</div>